export default __webpack_public_path__ + "static/B0235-c31f1dbb4eb1038403ea848233d32511.png";